module.exports = __webpack_public_path__ + "img/u889.846b012a.svg";